import React, { Fragment } from "react";
import { TenetsCard } from "../../components/About/TenetsCard";
import { PageHero } from "../../components/Global/PageHero";
import { BackToTop } from "../../templates/BackToTop";

export const RulesTenets = () => (
  <Fragment>
    <PageHero
      eyebrow="Our Standards"
      title="Rules &"
      highlight="Tenets"
      subtitle={'“Ye shall know the truth and the truth shall make you free” — John 8:32'}
    />
    <TenetsCard />
    <BackToTop />
  </Fragment>
);
